// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"d3054665","31":"49abebcc","213":"d38fe6e0","239":"6595967b","390":"d64bfc87","667":"5f9ce132","896":"3790fc4d"}[chunkId] + ".chunk.js";
};